import React, { useContext, useState } from "react";

const AnswerContext = React.createContext();
const SetAnswerContext = React.createContext();

export function useAnswer() {
  return useContext(AnswerContext);
}

export function useSetAnswer() {
  return useContext(SetAnswerContext);
}

export function AnswerProvider({ children }) {
  const [answer, setAnswer] = useState({});

  return (
    <AnswerContext.Provider value={answer}>
      <SetAnswerContext.Provider value={setAnswer}>
        {children}
      </SetAnswerContext.Provider>
    </AnswerContext.Provider>
  );
}
